import { render, staticRenderFns } from "./FormDownload.vue?vue&type=template&id=e4916c7c&scoped=true"
import script from "./FormDownload.vue?vue&type=script&lang=ts"
export * from "./FormDownload.vue?vue&type=script&lang=ts"
import style0 from "./FormDownload.vue?vue&type=style&index=0&id=e4916c7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4916c7c",
  null
  
)

export default component.exports